import { createTheme } from '@mui/material/styles';

/**
 * Lightweight MUI v5 theme used by the modernized Super Admin tools
 * (Course Review + Facility LMS). Kept local so it doesn't affect the
 * rest of the app, while aligning colours with the Orijin brand.
 */
const superAdminTheme = createTheme({
  palette: {
    primary: {
      main: '#0F48B8',
      dark: '#0F2C54',
      light: '#E8EEFB',
      contrastText: '#FFFFFF',
    },
    success: { main: '#2E7D32', light: '#E7F4E8' },
    warning: { main: '#B26A00', light: '#FBF0DD' },
    error: { main: '#C62828', light: '#FBE9E9' },
    grey: { 50: '#F8F9FB' },
    text: {
      primary: '#13243B',
      secondary: '#5A6B82',
    },
    divider: '#E3E8EF',
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: '1.5rem', fontWeight: 700 },
    h2: { fontSize: '1.25rem', fontWeight: 700 },
    subtitle2: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: 12 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
  },
});

export default superAdminTheme;
